// src/api/userApi.js
import axiosInstance from "./axiosConfig";

export const createUser = (userData) => {
  return axiosInstance.post("/users", userData);
};

export const getUsers = () => {
  return axiosInstance.get("/users");
};
